/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ISzfBusinessOpFormData } from './szf-business-op-form.data';
import { ISzfBusinessOpFormProps } from './szf-business-op-form.props.autogenerated';

export interface ISzfBusinessOpFormViewProps extends ISzfBusinessOpFormProps<ISzfBusinessOpFormData> {}

/**
 *
 * SzfBusinessOpForm component
 * @extends {React.PureComponent<ISzfBusinessOpFormProps<ISzfBusinessOpFormData>>}
 */
class SzfBusinessOpForm extends React.PureComponent<ISzfBusinessOpFormProps<ISzfBusinessOpFormData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default SzfBusinessOpForm;
